// extracted by mini-css-extract-plugin
module.exports = {"inputTitle":"claim-coin_inputTitle__19po-","input":"claim-coin_input__S4WHW","button":"claim-coin_button__2JdcP"};